module.exports = __webpack_public_path__ + "images/bf8f07d452658621da271cfd14c3b4ef.png";